import { Menu } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { LanguageSwitcher } from './LanguageSwitcher'

interface HeaderProps {
  onMenuClick: () => void
  title: string
}

export function Header({ onMenuClick, title }: HeaderProps) {
  const { t } = useTranslation()

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-gray-200 bg-white px-4 sm:gap-4 sm:px-6">
      <button
        onClick={onMenuClick}
        aria-label={t('common.openMenu')}
        className="text-gray-500 hover:text-gray-700 lg:hidden"
      >
        <Menu className="h-6 w-6" />
      </button>
      <h2 className="truncate text-lg font-semibold text-gray-900">{title}</h2>
      <div className="ml-auto">
        <LanguageSwitcher />
      </div>
    </header>
  )
}
